"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchCardLink = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Icons_1 = require("@amzn/atoz-web/Icons");
var View_1 = require("@amzn/atoz-web/View");
var Text_1 = require("@amzn/atoz-web/Text");
var Theme_1 = require("@amzn/atoz-web/Theme");
var PunchCardLink = function (_a) {
    var showAlertIcon = _a.showAlertIcon;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(Container, { dataTestId: "PunchCardLink" },
        react_1.default.createElement(PunchLinkText, null, t('time_and_attendance_PunchCard_in')),
        react_1.default.createElement(HorizontalLine, null,
            react_1.default.createElement(LeftDot, null),
            react_1.default.createElement(RightDot, null),
            showAlertIcon && (react_1.default.createElement(AlertIcon, { dataTestId: "PunchCardLinkIcon" },
                react_1.default.createElement(Icons_1.IconAlertCircleFill, { color: "red60-alpha90", size: Icons_1.IconSize.ExtraSmall })))),
        react_1.default.createElement(PunchLinkText, null, t('time_and_attendance_PunchCard_out'))));
};
exports.PunchCardLink = PunchCardLink;
var PunchLinkText = (0, Theme_1.styledWithTheme)(Text_1.Text)(function (_a) {
    var theme = _a.theme;
    return "\n    font-size: ".concat(theme.selectors.fontSize('T200'), "px; \n");
});
var Container = (0, Theme_1.styledWithTheme)(View_1.View)(function (_a) {
    var theme = _a.theme;
    return "\n  align-items: center;\n  display: flex;\n  height: ".concat(theme.selectors.space('S600'), "px;\n  justify-content: center;\n");
});
var HorizontalLine = (0, Theme_1.styledWithTheme)(View_1.View)(function (_a) {
    var theme = _a.theme;
    return "\n    background-color: black;\n    height: 3px;\n    margin-left: ".concat(theme.selectors.space('S200'), "px;\n    margin-right: ").concat(theme.selectors.space('S200'), "px;\n    position: relative;\n    width: 45px;\n  ");
});
var LeftDot = (0, Theme_1.styledWithTheme)(View_1.View)("\n    background-color: black;\n    border-radius: 50%;\n    border: 2px solid black;\n    height: 8px;\n    left: 0;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 8px;\n  ");
var RightDot = (0, Theme_1.styledWithTheme)(View_1.View)("\n    background-color: white;\n    border-radius: 50%;\n    border: 2px solid black;\n    height: 8px;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 8px;\n  ");
var AlertIcon = (0, Theme_1.styledWithTheme)(View_1.View)("\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, calc(-50% - 16px));\n  ");
